import {
  InvitationApi,
  InvitationEntityTypeApi,
} from 'api-typings/users/users';
import {
  EntityInvitation,
  Invitation,
  LinkInvitation,
} from './invitations.model';

export function invitationsTransformer(invitation: InvitationApi): Invitation {
  const baseInvitation = {
    id: invitation.id,
    inviterUserId: invitation.inviter_user_id,
    inviteeEntityId: invitation.invitee_entity_id,
    inviteeEntityType: invitation.invitee_entity_type,
    inviteeEmail: invitation.invitee_email,
    invitationType: invitation.invitation_type,
    contextId: invitation.context_id,
    status: invitation.status,
    timeCreated: invitation.time_created,
    timeMostRecentEmailSent: invitation.time_most_recent_email_sent,
  };

  return [
    InvitationEntityTypeApi.OPEN_LINK,
    InvitationEntityTypeApi.RESTRICTED_LINK,
  ].includes(invitation.invitee_entity_type)
    ? ({ ...baseInvitation, token: invitation.token } as LinkInvitation)
    : ({
        ...baseInvitation,
      } as EntityInvitation);
}
